export default class ContactInfo {
  person: string = "";
  email: string = "";
  address: string = "";
  phoneNumber: string = "";

  public constructor(init?: Partial<ContactInfo>) {
    Object.assign(this, init);
  }
}
